import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl-redux';
import 'core-js'

import App from './App'
import {store} from './store'

import messagesEn from './myapp_src/locale/en.json';
import messagesCn from './myapp_src/locale/cn.json';
import  {readUserLoginStatus}  from './myapp_src/services/MyAppServerComm.js'

const messages = {
  "en-US": messagesEn,
   "zh-CN": messagesCn,
};
const currentUser = readUserLoginStatus()
const locale = currentUser['locale']
//const locale = 'zh-CN'

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
   <IntlProvider  locale={locale} messages={messages[locale]}>
    <App/>
    </IntlProvider>
  </Provider>,
)
